// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const ArrowRight = createIcon(
  <path
    clipRule="evenodd"
    d="M13.5096 7.33588C13.8611 6.9844 14.431 6.98439 14.7824 7.33586L19.649 12.2023C19.8178 12.3711 19.9126 12.6 19.9126 12.8387C19.9126 13.0774 19.8178 13.3063 19.649 13.4751L14.7824 18.3417C14.431 18.6931 13.8611 18.6931 13.5097 18.3417C13.1582 17.9902 13.1582 17.4203 13.5097 17.0689L16.8398 13.7387L4.98737 13.7387C4.49032 13.7387 4.08737 13.3358 4.08737 12.8387C4.08737 12.3417 4.49032 11.9387 4.98737 11.9387L16.8398 11.9387L13.5097 8.60867C13.1582 8.2572 13.1582 7.68735 13.5096 7.33588Z"
    fillRule="evenodd"
  />,
);
